export default __webpack_public_path__ + "static/media/flexible.4b1aef8a.svg";